import React from "react";
import "./Fixed.css";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaFacebookF
} from "react-icons/fa";

export default function Fixed() {
  return (
    <div className="fixed-action-bar">
      
      <a href="tel:+919597839564" className="fab-item" aria-label="Call">
        <FaPhoneAlt />
      </a>

      <span className="fab-divider"></span>

      <a
        href="https://wa.me/919597839564"
        target="_blank"
        rel="noreferrer"
        className="fab-item"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>

      <span className="fab-divider"></span>

      <a
        href="mailto:info@radenvironex.com"
        className="fab-item"
        aria-label="Email"
      >
        <FaEnvelope />
      </a>

      <span className="fab-divider"></span>

      <a
        href="https://www.instagram.com/rad_environex/"
        className="fab-item"
        aria-label="Instagram"
      >
        <FaInstagram />
      </a>

      <span className="fab-divider"></span>

      <a
        href="https://www.facebook.com/profile.php?id=61588615206940"
        className="fab-item"
        aria-label="Facebook"
      >
        <FaFacebookF />
      </a>

    </div>
  );
}
